export const N_QUEST_FARM_PROGRESS = 'QUEST_FARM_PROGRESS';



/** WEBPACK FOOTER **
 ** ./src/game/props/propsN.ts
 **/